<template>
  <div class="pay-success-page">
    <div class="pay-success">
      <div class="pay-success__icon-wrap">
        <img class="pay-success__icon" :src="okIcon" alt="支付成功">
      </div>
      <p class="pay-success__text">支付成功</p>
      <p class="pay-success__hint">订单已支付完成</p>
    </div>
  </div>
</template>

<script>
import okIcon from './img/ok.png';

export default {
  name: 'PurchasePaySuccessPage',

  data() {
    return {
      okIcon,
    };
  },
};
</script>

<style scoped>
.pay-success-page {
  width: 100%;
  height: 100vh;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(180deg, #f6fcf8 0%, #ffffff 72%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
}

.pay-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  text-align: center;
  animation: fadeIn 0.45s ease-out both;
}

.pay-success__icon-wrap {
  position: relative;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
}

.pay-success__icon-wrap::before {
  content: '';
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(82, 196, 26, 0.16) 0%,
    rgba(82, 196, 26, 0) 70%
  );
  animation: glow 0.6s ease-out both;
}

.pay-success__icon {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  animation: popIn 0.5s cubic-bezier(0.34, 1.4, 0.64, 1) 0.05s both;
}

.pay-success__text {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #666;
  line-height: 1.5;
  letter-spacing: 0.5px;
  animation: slideUp 0.45s ease-out 0.12s both;
}

.pay-success__hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  animation: slideUp 0.45s ease-out 0.2s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes glow {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/user/purchaseService/PaySuccessPage.vue